<div class="table-container">
  <table
    class="spec-table px-4"
    aria-describedby="specificationList"
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="specId"
    matSortDirection="asc"
    multiTemplateDataRows>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          *ngIf="specificationList?.length"
          class="mx-3"
          (change)="masterToggle()"
          [checked]="selection.hasValue() && isEntirePageSelected()"
          [indeterminate]="selection.hasValue() && !isEntirePageSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox
          class="mx-3"
          [checked]="selection.isSelected(element)"
          (change)="selection.toggle(element); updateSelection()"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="specId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="specId">
        {{
          'mapping.specifications.invoiceSpecificationList.invoiceSpecificationTable.id' | translate
        }}
      </th>
      <td class="mr-2 td-link" mat-cell *matCellDef="let element" (click)="editSpec(element)">
        {{ element.specId }}
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="fileFormat">
        <th mat-header-cell *matHeaderCellDef>File Format</th>
        <td class="mr-2" mat-cell *matCellDef="let element">{{ element.fileFormat }}</td>
      </ng-container>

      <ng-container matColumnDef="spec">
        <th mat-header-cell *matHeaderCellDef>Specification</th>
        <td class="mr-2" mat-cell *matCellDef="let element">{{ element.spec }}</td>
      </ng-container> -->

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td class="mr-2" mat-cell *matCellDef="let element">
        <i
          class="icon-mat-info bi bi-file-earmark-text mr-4"
          matTooltip="{{
            'mapping.specifications.invoiceSpecificationList.invoiceSpecificationTable.importSpecification'
              | translate
          }} {{ element.specId }}"
          (click)="importSpec(element)"></i>

        <i
          class="icon-mat-info bi bi-download mr-4"
          matTooltip="{{
            'mapping.specifications.invoiceSpecificationList.invoiceSpecificationTable.downloadSpecification'
              | translate
          }} {{ element.specId }}"
          (click)="downloadSpecification(element)"></i>

        <i
          class="icon-mat-info bi bi-trash mr-4"
          matTooltip="{{
            'mapping.specifications.invoiceSpecificationList.invoiceSpecificationTable.delete'
              | translate
          }}"
          (click)="openDialogDelete([element?._id])"></i>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

    <tr
      mat-row
      *matRowDef="let element; columns: displayedColumns"
      class="expand-element-row"
      [class.detail-expanded-row]="expandedElement === element.specId"></tr>
    <tr class="mat-row text-center" *matNoDataRow>
      {{
        'mapping.specifications.invoiceSpecificationList.invoiceSpecificationTable.noDataAvailable'
          | translate
      }}
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[25, 50, 100, 200]" showFirstLastButtons></mat-paginator>
</div>
